import request from '@/utils/request';
// import { getToken } from "@/utils/auth"; // get token
import configR from '@/configs.js';
const API = configR.envConfigs.PORTAL_API;
const personAPI = configR.envConfigs.PERSON_CENTER_API;
let uniAuthUrl = '';
if(configR.envConfigs.LOGIN_WAY === 'uniAuth') {
  uniAuthUrl = JSON.parse(configR.envConfigs.AUTH_SETTING).url;
}

// 主题下导航栏页面查询
export function themeNavigation(params) {
  return request({
    url: `${API}v2/theme/themeNavigation`,
    method: 'get',
    params: params
  });
}
// 账号拥有的角色rolesByUser
export function rolesByUser() {
  return request({
    url: `${API}/v1/role/rolesByUser`,
    method: 'get'
  });
}

// 获取用户按钮权限
export function getUserButtonPermission() {
  return request({
    url: `${API}api/rest/resource/queryCurrentUserResourceByType?type=BUTTON`,
    method: 'get',
  });
}

// 用户导航 - 获取列表
export function getUserNav() {
  return request({
    url: `${API}v1/user/config/get`,
    method: 'get',
  });
}

// 用户导航 - 保存排序
export function saveUserNav(data) {
  return request({
    url: `${API}api/proxy/service/api/common/desktop/setting/saveNavigationBarSetting`,
    method: 'post',
    data: data,
  });
}

// 用户桌面 - 主题
export function getUserTheme() {
  return request({
    url: `${API}v2/theme/themeInfo`,
    method: 'get',
  });
}
// 获取个人配置接口
export function getPersonlSet() {
  return request({
    url: `${API}/v1/config/theme/personal/getSetting?code=`,
    method: 'get',
  });
}
// 保存个人配置接口
export function postPersonlSet(data){
  return request({
    url: `${API}/v2/theme/set`,
    method: 'post',
    data:data
  })
}
// 用户桌面 - 获取一级桌面
export function getUserDesktop() {
  return request({
    url: `${API}api/proxy/service/api/common/desktop/setting/userDesktopSettingInfo`,
    method: 'get',
  });
}

// 用户桌面 - 获取当前桌面的组件
export function getUserComponents(id) {
  return request({
    url: `${API}api/proxy/service/api/common/desktop/setting/userSonDesktopSettingInfo?cardId=${id}`,
    method: 'get',
  });
}

// 用户桌面 - 保存桌面组件
export function saveUserComponents(data) {
  return request({
    url: `${API}api/proxy/service/api/common/desktop/setting/saveUserDesktopSetting`,
    method: 'post',
    data: data,
  });
}

// 获取子组件
export function getSubComponents(params) {
  return request({
    url: `${API}api/proxy/service/api/common/desktop/setting/userSonDesktopSettingInfo`,
    method: 'get',
    params: params,
  });
}

// 个人信息 - 成绩
export function getUserGrade() {
  return request({
    url: `${API}api/proxy/personalData/api/common/userdata/score/getScore`,
    method: 'get',
  });
}

// 个人信息 - 图书借阅
export function getUserBook() {
  return request({
    url: `${API}api/proxy/personalData/api/common/userdata/book/getUnReturnCount`,
    method: 'get',
  });
}

// 个人信息 - 邮箱
export function getUserMail() {
  return request({
    url: `${API}api/proxy/personalData/api/common/userdata/email/getEmailNew`,
    method: 'get',
  });
}
// 个人信息 - 邮箱 -v2
export function getMailbox() {
  return request({
    url: `${API}v2/personalData/getMailbox`,
    method: 'get',
  });
}

// 个人信息 - 论文
export function getUserPaper() {
  return request({
    url: `${API}api/proxy/personalData/api/common/userdata/paper/getPaperInfo`,
    method: 'get',
  });
}

// 个人信息 - 科研
export function getUserResearch() {
  return request({
    url: `${API}api/proxy/personalData/api/common/userdata/scientific/count`,
    method: 'get',
  });
}

// 个人信息 - 记录系统访问信息
export function getSystemVisitSave() {
  return request({
    url: `${API}v1/personalData/systemVisitSave`,
    method: 'get',
  });
}
// 个人信息 - 获取用户头像
export function getUserAvatar(data) {
  return request({
    url: `${personAPI}api/v1/me/portrait`,
    method: 'get',
    responseType: 'arraybuffer',
    params: data.params,
  });
}


// 获取用户浏览历史记录
export function getRecordPreviewHistory() {
  return request({
    url: `${API}v1/config/system/getRecordPreviewHistory`,
    method: "get"
  });
}
// 添加用户浏览历史记录
export function setRecordPreviewHistory(param) {
  return request({
    url: `${API}v1/config/system/setRecordPreviewHistory`,
    method: "get",
    params: param,
  });
}
// 得到JWT公钥
export function getPublicKey() {
  return request({
    url: `${uniAuthUrl}idtoken/publicKey`,
    method: 'get',
    headerType: 'publicKey'
  });
}
// 个人信息
export function getUserInfo() {
  return request({
    url: `${personAPI}api/user`,
    method: 'get',
  });
}
// 个人信息
export function getPersonalInfo() {
  return request({
    url: `${personAPI}api/v1/personal/me/user`,
    method: 'get',
  });
}


